import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { set } from 'lodash';
import { Observable } from 'rxjs';
import { FileInformation } from 'src/app/shared/models/app-models';
export interface FileToUpload {
  files: FileInformation[];
}

@Injectable()
export class FileStore extends ComponentStore<FileToUpload> {
  constructor() {
    super({ files: [] });
  }

  readonly files$: Observable<FileInformation[]> = this.select(
    (state) => state.files
  );
  readonly addFile = this.updater((state, file: FileInformation) => {
    return { files: [...state.files, file] };
  });
  readonly removeFile = this.updater((state, index: number) => {
    let array = state.files.slice();
    // if it is already uploaded, mark it as deleted instead of removing it
    if (!array[index].fromDatabase) {
      array.splice(index, 1);
    } else {
      array[index].attachment = {
        ...array[index].attachment,
        isDeleted: true,
      };
    }
    return { files: array };
  });
  readonly resetFiles = this.updater(() => {
    return { files: [] };
  });
  readonly updateFile = this.updater((state, { file, index }: any) => {
    let stateCopy = state.files.slice();
    stateCopy[index] = {
      ...file,
    };
    return { files: stateCopy };
  });
}
